import React from 'react';
import { Link } from 'gatsby';
import type { GatsbyLinkProps } from 'gatsby';

type LinkWithQueryProps = Omit<GatsbyLinkProps<object>, 'ref'>;

export const LinkWithQuery = (props: LinkWithQueryProps): React.JSX.Element => {
  const { to, children } = props;
  const search = window.location.search;

  return (
    <Link {...props} to={to + search}>
      {children}
    </Link>
  );
};
